import { render, staticRenderFns } from "./ClosingComponent.vue?vue&type=template&id=c1452968&"
import script from "./ClosingComponent.vue?vue&type=script&lang=js&"
export * from "./ClosingComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClosingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports